import "./recommended-products.js";
import "./js.cookie.js";
const { buttonState } = await import(`./button-state.js?v=${Date.now()}`);
class CheckoutButton extends HTMLElement {
  constructor() {
    super();
    let button = this.querySelector(".create-checkout");
    let createCheckout = async () => {
    };
    button == null ? void 0 : button.addEventListener("click", (e) => {
      e.preventDefault();
      createCheckout();
      buttonState.loading(button);
    });
  }
}
if (customElements.get("checkout-button") === void 0) {
  customElements.define("checkout-button", CheckoutButton);
}
